import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from '@app/features/auth/auth.actions';
import { APPLICATION_SESSION } from '@core/services/auth/application-session';
import { first, firstValueFrom } from 'rxjs';
import { selectAuth } from '@app/features/auth/auth.selectors';

export async function authStateInitializer(): Promise<void> {
  const store = inject(Store);
  const session = inject(APPLICATION_SESSION);
  try {
    await session.initialize();
    await firstValueFrom(
      store
        .select(selectAuth)
        .pipe(
          first(
            (state) =>
              !state.authenticated ||
              state.isSecurityAdministrator ||
              (!state.sessionTransitioning &&
                (state.accessStatus === 'ready' ||
                  state.accessStatus === 'failed')),
          ),
        ),
    );
  } catch {
    store.dispatch(
      AuthActions.sessionFailed({ message: 'GENERAL.AUTH_UNAVAILABLE' }),
    );
  } finally {
    store.dispatch(AuthActions.initEnd());
  }
}
